let domain = "";

if (/bsms-(?!staging)\w+-kasse\.gomus\.de/.test(document.location.host)) {
  // special case for bsms, all POS go to single API endpoint
  domain = "bsms.gomus.de";
} else if (/antwerpen-(?!staging)\w+-kasse\.gomus\.be/.test(document.location.host)) {
  // special case for antwerpen, all POS go to single API endpoint
  domain = "antwerpen.gomus.be";
} else {
  // default behaviour strip -kasse, -integration and .demo.kasse
  domain = document.location.host.replace('.demo.kasse', '').replace('-kasse', '').replace('-integration', '');
}

export const environment = {
  production: true,
  domain: domain,
  shopDomain: document.location.host,
  environment: 'production',
  version: '5.1.1',
  commit_sha: '10dd43a909650c2514520ce7f0a7062689a764a0',
  rollbarAccessToken: 'e8baa210d636404ca2e7cc5370391c9f',
};
